import React from 'react';
import { TestimonialCard } from './TestimonialCard';
import { Button } from './Button';
export const TestimonialsSection = () => {
  const testimonials = [{
    quote: 'Glad to reconnect with these sessions. I was able to get back and grounded in my body after a brain injury. These sessions are great... loved the live group I did last week. Thanks for it being affordable and effective!',
    author: 'Kaye',
    date: '2 weeks ago'
  }, {
    quote: "I have been searching for years about how to get rid of my anxiety. I think I have finally found it in this program. I have completed my first day and I'm looking forward to this healing journey!",
    author: 'Chris',
    date: '1 month ago'
  }, {
    quote: 'Hi! I joined the program 3 days ago, and had two nights of really good sleep after learning the first two exercises. I am impressed how powerful these simple techniques are and the effect they are having in me!',
    author: 'Mari',
    date: '3 weeks ago'
  }, {
    quote: 'If you feel tired, stressed, anxious, burned out and demotivated to step out from this exhausted circle, these beautiful people from Neurotoned help you with simple but meaningful small steps. Nobody is pushing you, you can do it in your own pace.',
    author: 'Mihaela P.',
    date: '1 week ago'
  }, {
    quote: "I just started my second day and thought oh no it's the same as what I have been reading in books, wrong she explained why you need to chew and why you needed to visually ground and to be aware of your surroundings. I couldn't be happier!",
    author: 'Jackie S.',
    date: '2 days ago'
  }];
  return <section className="bg-gradient-to-b from-teal-800 to-teal-700 text-white py-16" data-id="element-275">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-276">
        <h2 className="text-3xl md:text-4xl font-bold mb-8 text-center" data-id="element-277">
          Real Results From Real People Who Already Knew the Science
        </h2>
        <div className="mb-10 max-w-3xl mx-auto" data-id="element-278">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/qPKRpbd8Bb7Epcj57bgXpG/11.2.png" alt="Happy Neurotoned users with their journals" className="w-full rounded-lg shadow-xl mb-8" data-id="element-279" />
        </div>
        <div className="mb-10" data-id="element-280">
          <p className="text-lg text-center mb-8" data-id="element-281">
            <strong data-id="element-282">
              You don't need to be convinced the nervous system matters.
            </strong>{' '}
            You need something that actually works.
          </p>
          <div className="flex items-center justify-center mb-8" data-id="element-283">
            <div className="flex items-center" data-id="element-284">
              {[...Array(5)].map((_, i) => <svg key={i} className="w-8 h-8 text-[#00b67a] fill-[#00b67a]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" data-id="element-285">
                  <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" data-id="element-286" />
                </svg>)}
            </div>
            <span className="ml-2 text-xl font-semibold text-white" data-id="element-287">
              4.9/5 on Trustpilot
            </span>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8" data-id="element-288">
            {testimonials.map((testimonial, index) => <TestimonialCard key={index} quote={testimonial.quote} author={testimonial.author} date={testimonial.date} data-id="element-289" />)}
          </div>
          <div className="flex justify-center" data-id="element-290">
            <Button link="https://www.trustpilot.com/review/neurotoned.com" data-id="element-291">
              See More Reviews ➔
            </Button>
          </div>
        </div>
      </div>
    </section>;
};